// extracted by mini-css-extract-plugin
module.exports = {"title":"AllMerch_title__21fx4","merchList":"AllMerch_merchList__1Q3AC"};